module.exports = __webpack_public_path__ + "static/media/iconExclamationMark1.06ec05f0.svg";